import React from 'react';
import { IItemCreationSubsectionInputProps, ItemCreationSubsection } from '~/Components';
import { useTranslation } from 'react-i18next';
import { ItemCreationValidInput } from '~/Components/ItemCreation/ItemCreationSubsection/ItemCreationSubsectionInput.model';
import { ExtendedNotificationSettings } from './useUserProfileNotificationSettings';
import { useHasAccess } from '~/Hooks';
import { AccessList } from '~/Hooks/useHasAccess/accessList.types';
import { LiveTv, ShoppingCart } from '@mui/icons-material';
import { Bell, EventBusy, EventSuccess, FileCross } from '~/Components/Icons';

export const UserProfileNotificationSettingsGeneralSection = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data: ExtendedNotificationSettings,
) => {
  const { t } = useTranslation();
  const { hasAccess } = useHasAccess();

  // const manipulation = (
  //   newValue: boolean,
  //   newValues: Partial<ExtendedNotificationSettings>,
  //   oldValues: Partial<ExtendedNotificationSettings>,
  //   currentKey: keyof ExtendedNotificationSettings,
  //   dependencyKey: keyof ExtendedNotificationSettings,
  // ) => {
  //   if (oldValues[currentKey] !== newValue) {
  //     return newValue;
  //   }
  //   if (newValues[dependencyKey] !== oldValues[dependencyKey]) {
  //     return oldValues[dependencyKey];
  //   }
  //   return newValue;
  // };

  const LocationGeneralDetails: IItemCreationSubsectionInputProps<
    Partial<ExtendedNotificationSettings>
  >[] = [
    {
      icon: <Bell />,
      label: t('form.field.notifications.dailyMailEnabled'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'dailyMailEnabled',
    },
    {
      icon: <EventSuccess />,
      label: t('form.field.notifications.receiveBookingMailCopy'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'receiveBookingMailCopy',
      // children: [
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.bookingMailCopyIntervalImmediately'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'bookingMailCopyIntervalImmediately',
      //     dependencyList: ['bookingMailCopyIntervalDaily'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'bookingMailCopyIntervalImmediately',
      //         'bookingMailCopyIntervalDaily',
      //       ),
      //     hidden: !data.receiveBookingMailCopy,
      //   },
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.bookingMailCopyIntervalDaily'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'bookingMailCopyIntervalDaily',
      //     dependencyList: ['bookingMailCopyIntervalImmediately'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'bookingMailCopyIntervalDaily',
      //         'bookingMailCopyIntervalImmediately',
      //       ),
      //     hidden: !data.receiveBookingMailCopy,
      //   },
      // ],
    },
    {
      icon: <EventBusy />,
      label: t('form.field.notifications.receiveCancellationMailCopy'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'receiveCancellationMailCopy',
      // children: [
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.cancellationMailCopyIntervalImmediately'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'cancellationMailCopyIntervalImmediately',
      //     dependencyList: ['cancellationMailCopyIntervalDaily'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'cancellationMailCopyIntervalImmediately',
      //         'cancellationMailCopyIntervalDaily',
      //       ),
      //     hidden: !data.receiveCancellationMailCopy,
      //   },
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.cancellationMailCopyIntervalDaily'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'cancellationMailCopyIntervalDaily',
      //     dependencyList: ['cancellationMailCopyIntervalImmediately'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'cancellationMailCopyIntervalDaily',
      //         'cancellationMailCopyIntervalImmediately',
      //       ),
      //     hidden: !data.receiveCancellationMailCopy,
      //   },
      // ],
    },
  ];

  if (hasAccess(AccessList.RECEIVE_CONTRACT_CANCELLATION)) {
    LocationGeneralDetails.push({
      icon: <FileCross />,
      label: t('form.field.notifications.receiveContractRenewalCancellationEmail'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'receiveContractRenewalCancellationEmail',
    });
  }

  if (hasAccess(AccessList.RECEIVE_CHECKOUT_EMAIL)) {
    LocationGeneralDetails.push({
      icon: <ShoppingCart />,
      label: t('form.field.notifications.receiveCheckoutMailCopy'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'receiveCheckoutMailCopy',
      // children: [
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.checkoutMailCopyIntervalImmediately'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'checkoutMailCopyIntervalImmediately',
      //     dependencyList: ['checkoutMailCopyIntervalDaily'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'checkoutMailCopyIntervalImmediately',
      //         'checkoutMailCopyIntervalDaily',
      //       ),
      //     hidden: !data.receiveCheckoutMailCopy,
      //   },
      //   {
      //     icon: <GroupSport />,
      //     label: t('form.field.notifications.checkoutMailCopyIntervalDaily'),
      //     type: ItemCreationValidInput.SWITCHER,
      //     name: 'checkoutMailCopyIntervalDaily',
      //     dependencyList: ['checkoutMailCopyIntervalImmediately'],
      //     manipulation: (newValue, dependency, value) =>
      //       manipulation(
      //         newValue,
      //         dependency,
      //         value,
      //         'checkoutMailCopyIntervalDaily',
      //         'checkoutMailCopyIntervalImmediately',
      //       ),
      //     hidden: !data.receiveCheckoutMailCopy,
      //   },
      // ],
    });
  }

  if (hasAccess(AccessList.RECEIVE_LIVE_STREAM_REMINDER)) {
    LocationGeneralDetails.push({
      icon: <LiveTv />,
      label: t('form.field.notifications.receiveLivestreamReminder'),
      type: ItemCreationValidInput.SWITCHER,
      name: 'receiveLivestreamReminder',
    });
  }

  return <ItemCreationSubsection items={LocationGeneralDetails} />;
};
